import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getSimpleDate', standalone: true })
export class GetSimpleDatePipe implements PipeTransform {

    transform(monthObject, day: number): string {
        if (!monthObject || !day) {
            return '';
        }

        // Make sure single days start with 0
        const dayStr = day.toString().padStart(2, '0');

        return `${monthObject.selectedYear}-${monthObject.selectedMonthNumber}-${dayStr}`;
    }

}
